@if (isCompleted()) {
  <div class="h-full grid grid-rows-[max-content_auto] overflow-hidden">
    <ctr-navigation
      (menuClick)="sidenav.toggle()"
      [actualLanguage]="actualLanguage() ?? null"
      [languages]="languages()"
      (changeLanguage)="changeLanguage.emit($event)"
      [logo]="hotelLogo() ?? null"
    >
    </ctr-navigation>

    <mat-sidenav-container class="h-full">
      <mat-sidenav #sidenav>
        <ctr-menu
          [title]="hotelName() ?? ''"
          (logoutClick)="logout.emit()"
          [logo]="hotelLogo() ?? null"
          [navItems]="navItems()"
          [subtitle]="employerName() ?? ''"
          [logoutText]="logOutName() ?? ''"
        ></ctr-menu>
      </mat-sidenav>

      <mat-sidenav position="end" #rightSidenav [style.--mat-sidenav-container-width]="sideRightWidth() || undefined">
        <ng-content select="[ctr-right-sidenav]"></ng-content>
      </mat-sidenav>

      <mat-sidenav-content class="h-screen">
        <div class="h-full grid grid-rows-[max-content_auto_max-content]">
          <div class="max-w-7xl w-full mx-auto px-10">
            <ng-content select="[ctr-header]"></ng-content>
          </div>
          <div class="overflow-auto h-full w-full">
            <div class="px-10 mx-auto w-full" [style.max-width]="maxSize" [class.h-full]="isFloatingFooter()">
              <ng-content select="[ctr-body]"></ng-content>
            </div>

            @if (!isFloatingFooter()) {
              <ng-container *ngTemplateOutlet="footer"></ng-container>
            }
          </div>
          @if (isFloatingFooter()) {
            <ng-container *ngTemplateOutlet="footer"></ng-container>
          }
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
} @else {
  <div class="h-full flex justify-center items-center">
    <mat-spinner></mat-spinner>
  </div>
}

<ng-template #footer>
  <ng-content select="ctr-footer"></ng-content>
</ng-template>
